import React from 'react'
import { required, SelectInputProps } from 'react-admin'
import { DepSelectInput } from '../inputs/DepSelectInput'
import { COMMON_FIELDS } from '../../providers/localization/constant'
import { useFormContext } from 'react-hook-form'

const defaultProps = {
  label: `${COMMON_FIELDS}.target_link.label`,
  source: 'target_link',
  choices: [
    { id: 'news', name: `${COMMON_FIELDS}.target_link.choices.public_news` },
    { id: 'privilege', name: `${COMMON_FIELDS}.target_link.choices.privilege` },
    { id: 'external_browser', name: `${COMMON_FIELDS}.target_link.choices.external_browser` },
  ],
}

export const TargetLinkSelectInput: React.FC<SelectInputProps> = ({
  label,
  source,
  choices,
  disabled = false,
  ...props
}) => {
  const { setValue } = useFormContext()

  const targetLinkOnChange = (e): void => {
    const value = e.target.value
    const actionType = value === 'news' || value === 'privilege' ? 2 : 3
    setValue('action_type', actionType)
  }
  return (
    <DepSelectInput
      depField='action'
      expectedValue='link'
      margin='none'
      disabled={disabled}
      fullWidth
      label={label}
      source={source}
      choices={choices}
      validate={[required()]}
      translateChoice={true}
      onChange={targetLinkOnChange}
      {...props}
    />
  )
}

TargetLinkSelectInput.defaultProps = defaultProps
